import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const TOUR_GROUP_ROUTES: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./../home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: false }
  },
  {
    path: 'recruiting',
    loadComponent: () => import('./recruiting-tour-group-list/recruiting-tour-group-list.component').then(m => m.RecruitingTourGroupListComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: false }
  },
  {
    path: 'joined',
    loadComponent: () => import('./joined-tour-group-list/joined-tour-group-list.component').then(m => m.JoinedTourGroupListComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  },
  {
    path: 'joined/:year',
    loadComponent: () => import('./joined-tour-group-list/joined-tour-group-list.component').then(m => m.JoinedTourGroupListComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  },
  {
    path: 'create',
    loadComponent: () => import('./create-tour-group/create-tour-group.component').then(m => m.CreateTourGroupComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  },
  {
    path: 'edit/:tourGroupDocId',
    loadComponent: () => import('./edit-tour-group/edit-tour-group.component').then(m => m.EditTourGroupComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  },
  {
    path: 'review/:tourGroupDocId',
    loadComponent: () => import('./review-tour-group/review-tour-group.component').then(m => m.ReviewTourGroupComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  },
  {
    path: 'admin-list',
    loadComponent: () => import('./all-tour-group-list/all-tour-group-list.component').then(m => m.AllTourGroupListComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  },
  {
    path: 'admin-list/:year',
    loadComponent: () => import('./all-tour-group-list/all-tour-group-list.component').then(m => m.AllTourGroupListComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  },
  {
    path: 'admin-statistics',
    loadComponent: () => import('./admin-statistics/admin-statistics.component').then(m => m.AdminStatisticsComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  }
];
